<!-- NEWS AND TENDERS - STARTS -->
<section class="about-us" *ngIf="showAbout">
    <div class="container-xxl">
        <div class="row align-items-center" data-aos="fade-up" data-aos-duration="600" data-aos-once="true">
            <div class="col-lg-12 mb-5 mb-lg-0">
                <div class="about-us-area text-center">
                    <div class="title screen-reader">
                        <h4>{{ language=='English'?this.encDec.decodeHtml(zoneDetails.title):this.encDec.decodeHtml(zoneDetails.titleInHindi) }}</h4>
                    </div>
                    <div class="about-us-details">
                        <p class="font-adjust screen-reader">{{ language=='English'?this.encDec.decodeHtml(zoneDetails.description):this.encDec.decodeHtml(zoneDetails.descriptionInHindi) }}</p>
                        <a [attr.title]="language=='English'?'Read More':'और पढ़ें'" href="javascript:void(0);" *ngIf="zoneDetails.selectMenu!=''" (click)="goToContentPage(zoneDetails.selectMenu)" class="btn btn-sm btn-outline-dark mt-3 px-3 py-2 screen-reader">{{ language=='English'? 'Read More' : 'और पढ़ें' }}</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- NEWS AND TENDERS - ENDS -->